import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  "aria-label": "breadcrumb",
  class: "mt-5 pt-5 ps-3"
}
const _hoisted_2 = { class: "breadcrumb mb-3" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row mb-4" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row align-items-center" }
const _hoisted_14 = { class: "col-md-8" }
const _hoisted_15 = { class: "mb-2" }
const _hoisted_16 = {
  key: 0,
  class: "badge bg-info ms-2 text-capitalize"
}
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "d-flex gap-3 flex-wrap" }
const _hoisted_19 = { class: "col-md-4 text-md-end" }
const _hoisted_20 = { class: "d-flex align-items-start justify-content-end gap-2" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "card-header" }
const _hoisted_25 = {
  class: "nav nav-tabs card-header-tabs",
  role: "tablist"
}
const _hoisted_26 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_27 = {
  key: 0,
  class: "badge bg-primary ms-1"
}
const _hoisted_28 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "card mb-4 border-0 shadow-sm overflow-hidden" }
const _hoisted_32 = { class: "card-header bg-white border-bottom-0 pt-4 pb-0" }
const _hoisted_33 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-3" }
const _hoisted_34 = { class: "btn-group btn-group-sm p-1 bg-light rounded-pill" }
const _hoisted_35 = { class: "card-body p-4" }
const _hoisted_36 = {
  key: 0,
  class: "upload-zone transition-fade"
}
const _hoisted_37 = { class: "row g-3" }
const _hoisted_38 = { class: "col-lg-8" }
const _hoisted_39 = { class: "d-flex align-items-center w-100" }
const _hoisted_40 = { class: "flex-grow-1 overflow-hidden" }
const _hoisted_41 = {
  key: 0,
  class: "text-truncate fw-bold"
}
const _hoisted_42 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_43 = { class: "col-lg-4" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = {
  key: 1,
  class: "url-zone transition-fade"
}
const _hoisted_48 = { class: "row g-3" }
const _hoisted_49 = { class: "col-md-5" }
const _hoisted_50 = { class: "input-wrapper" }
const _hoisted_51 = { class: "input-group" }
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = { class: "input-group" }
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  key: 2,
  class: "text-zone transition-fade"
}
const _hoisted_59 = {
  key: 3,
  class: "prompt-zone transition-fade"
}
const _hoisted_60 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_61 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_62 = {
  key: 2,
  class: "table-responsive theme-scrollbar"
}
const _hoisted_63 = { class: "table table-hover align-middle" }
const _hoisted_64 = { class: "text-end" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-lg-8 mx-auto" }
const _hoisted_70 = { class: "mb-4" }
const _hoisted_71 = { class: "mb-3" }
const _hoisted_72 = { class: "row mb-3" }
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = { key: 0 }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_78 = { class: "mb-3" }
const _hoisted_79 = { class: "card-body" }
const _hoisted_80 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_81 = { class: "mb-0" }
const _hoisted_82 = { class: "badge bg-success" }
const _hoisted_83 = { class: "text-muted small mb-2" }
const _hoisted_84 = { class: "retrieval-content" }
const _hoisted_85 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_86 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_87 = { class: "modal-dialog modal-lg" }
const _hoisted_88 = { class: "modal-content" }
const _hoisted_89 = { class: "modal-body" }
const _hoisted_90 = { class: "mb-3" }
const _hoisted_91 = { class: "mb-3" }
const _hoisted_92 = { class: "modal-footer" }
const _hoisted_93 = ["disabled"]
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { class: "modal-dialog modal-lg" }
const _hoisted_97 = { class: "modal-content" }
const _hoisted_98 = { class: "modal-body" }
const _hoisted_99 = { class: "mb-3" }
const _hoisted_100 = { class: "mb-3" }
const _hoisted_101 = { class: "modal-footer" }
const _hoisted_102 = ["disabled"]
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { key: 1 }
const _hoisted_105 = { class: "modal-dialog" }
const _hoisted_106 = { class: "modal-content" }
const _hoisted_107 = { class: "modal-body" }
const _hoisted_108 = { class: "modal-footer" }
const _hoisted_109 = ["disabled"]
const _hoisted_110 = { key: 0 }
const _hoisted_111 = { key: 1 }

import { ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import apiService from "@/services/apiService";
import { Modal } from "bootstrap";

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'KnowledgeBaseDetails',
  setup(__props) {

const router = useRouter();
const route = useRoute();

// Computed
const knowledgeBaseId = computed(() => route.params.id as string);

// Data
const knowledgeBase = ref<any>(null);
const documents = ref<any[]>([]);
const isLoading = ref(false);
const isLoadingDocuments = ref(false);
const activeTab = ref("documents");
const uploadMethod = ref("file"); // 'file', 'url', 'text'

// File upload
const fileInputRef = ref<HTMLInputElement | null>(null);
const selectedFile = ref<File | null>(null);
const isUploadingFile = ref(false);

// URL input
const urlInput = ref("");
const urlTitle = ref("");
const isAddingUrl = ref(false);

// Text modal
const addTextModalRef = ref<HTMLElement | null>(null);
const textTitle = ref("");
const textContent = ref("");
const isAddingText = ref(false);

// Prompt modal/input
const addPromptModalRef = ref<HTMLElement | null>(null);
const promptTitle = ref("");
const promptInput = ref("");
const isGeneratingPrompt = ref(false);

// Delete document
const deleteDocumentModalRef = ref<HTMLElement | null>(null);
const documentToDelete = ref<any>(null);
const isDeletingDocument = ref(false);

// Retrieval test
const testQuery = ref("");
const topK = ref(5);
const testResults = ref<any[]>([]);
const isTesting = ref(false);
const hasTestedOnce = ref(false);

// Methods
const loadKnowledgeBase = async () => {
  isLoading.value = true;
  try {
    const response = await apiService.getKnowledgeBaseById(
      knowledgeBaseId.value
    );
    knowledgeBase.value = response;
  } catch (err: any) {
    console.error("Error loading knowledge base:", err);
    showToast(
      err?.response?.data?.message || "Failed to load knowledge base",
      "error"
    );
  } finally {
    isLoading.value = false;
  }
};

const loadDocuments = async () => {
  isLoadingDocuments.value = true;
  try {
    const response = await apiService.getKnowledgeBaseDocuments(
      knowledgeBaseId.value
    );
    documents.value = response.data || response.documents || [];
  } catch (err: any) {
    console.error("Error loading documents:", err);
    showToast(
      err?.response?.data?.message || "Failed to load documents",
      "error"
    );
  } finally {
    isLoadingDocuments.value = false;
  }
};

const handleFileSelect = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    selectedFile.value = target.files[0];
  }
};

const handleFileUpload = async () => {
  if (!selectedFile.value) return;

  isUploadingFile.value = true;
  try {
    await apiService.uploadKnowledgeBaseDocument(
      knowledgeBaseId.value,
      selectedFile.value
    );
    showToast("File uploaded successfully", "success");

    // Reset
    selectedFile.value = null;
    if (fileInputRef.value) {
      fileInputRef.value.value = "";
    }

    // Reload documents
    loadDocuments();
  } catch (err: any) {
    console.error("Error uploading file:", err);
    showToast(err?.response?.data?.message || "Failed to upload file", "error");
  } finally {
    isUploadingFile.value = false;
  }
};

const handleAddUrl = async () => {
  if (!urlInput.value) return;

  isAddingUrl.value = true;
  try {
    await apiService.addKnowledgeBaseUrl(
      knowledgeBaseId.value,
      urlInput.value,
      urlTitle.value || undefined
    );
    showToast("URL added successfully", "success");

    // Reset
    urlInput.value = "";
    urlTitle.value = "";

    // Reload documents
    loadDocuments();
  } catch (err: any) {
    console.error("Error adding URL:", err);
    showToast(err?.response?.data?.message || "Failed to add URL", "error");
  } finally {
    isAddingUrl.value = false;
  }
};

const showAddTextModal = () => {
  const modalElement = addTextModalRef.value;
  if (modalElement) {
    const modal = new Modal(modalElement);
    modal.show();
  }
};

const handleAddText = async () => {
  if (!textTitle.value || !textContent.value) return;

  isAddingText.value = true;
  try {
    await apiService.addKnowledgeBaseText(
      knowledgeBaseId.value,
      textTitle.value,
      textContent.value
    );
    showToast("Text content added successfully", "success");

    // Close modal
    const modalElement = addTextModalRef.value;
    if (modalElement) {
      const modal = Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }

    // Reset
    textTitle.value = "";
    textContent.value = "";

    // Reload documents
    loadDocuments();
  } catch (err: any) {
    console.error("Error adding text:", err);
    showToast(err?.response?.data?.message || "Failed to add text", "error");
  } finally {
    isAddingText.value = false;
  }
};

const showAddPromptModal = () => {
  const modalElement = addPromptModalRef.value;
  if (modalElement) {
    const modal = new Modal(modalElement);
    modal.show();
  }
};

const handleGeneratePrompt = async () => {
  if (!promptTitle.value || !promptInput.value) return;  
  isGeneratingPrompt.value = true;
  try {
    await apiService.generateKnowledgeBasePrompt(
      knowledgeBaseId.value,
      {
        title: promptTitle.value,
        prompt: promptInput.value, 
      }
    );
    showToast("Knowledge base generation started successfully", "success");

    // Close modal
    const modalElement = addPromptModalRef.value;
    if (modalElement) {
      const modal = Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }

    // Reset
    promptTitle.value = "";
    promptInput.value = "";
    
    loadDocuments();
  } catch (err: any) {
    console.error("Error generating knowledge base from prompt:", err);
    showToast(err?.response?.data?.message || "Failed to generate knowledge base", "error");
  } finally {
    isGeneratingPrompt.value = false;
  }
};

const viewDocument = (doc: any) => {
  // You can implement a modal to show document details
  alert(`Document: ${doc.title}\nStatus: ${doc.status}`);
};

const confirmDeleteDocument = (doc: any) => {
  documentToDelete.value = doc;
  const modalElement = deleteDocumentModalRef.value;
  if (modalElement) {
    const modal = new Modal(modalElement);
    modal.show();
  }
};

const deleteDocument = async () => {
  if (!documentToDelete.value) return;

  isDeletingDocument.value = true;
  try {
    await apiService.deleteKnowledgeBaseDocument(
      knowledgeBaseId.value,
      documentToDelete.value._id || documentToDelete.value.id
    );
    showToast("Document deleted successfully", "success");

    // Close modal
    const modalElement = deleteDocumentModalRef.value;
    if (modalElement) {
      const modal = Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }

    documentToDelete.value = null;
    loadDocuments();
  } catch (err: any) {
    console.error("Error deleting document:", err);
    showToast(
      err?.response?.data?.message || "Failed to delete document",
      "error"
    );
  } finally {
    isDeletingDocument.value = false;
  }
};

const handleTestRetrieval = async () => {
  if (!testQuery.value) return;

  isTesting.value = true;
  hasTestedOnce.value = true;
  try {
    const response = await apiService.testKnowledgeBaseRetrieval(
      knowledgeBaseId.value,
      testQuery.value,
      topK.value
    );
    testResults.value = response.results || response.data || [];
    showToast(
      `Found ${testResults.value.length} results`,
      testResults.value.length > 0 ? "success" : "info"
    );
  } catch (err: any) {
    console.error("Error testing retrieval:", err);
    showToast(
      err?.response?.data?.message || "Failed to test retrieval",
      "error"
    );
    testResults.value = [];
  } finally {
    isTesting.value = false;
  }
};

const getSourceTypeBadgeClass = (sourceType: string): string => {
  switch (sourceType?.toLowerCase()) {
    case "file":
    case "upload":
      return "bg-primary";
    case "url":
    case "web":
      return "bg-info";
    case "text":
      return "bg-success";
    default:
      return "bg-secondary";
  }
};

const getStatusBadgeClass = (status: string): string => {
  switch (status?.toLowerCase()) {
    case "processed":
    case "ready":
    case "completed":
      return "bg-success";
    case "processing":
      return "bg-warning";
    case "failed":
    case "error":
      return "bg-danger";
    default:
      return "bg-secondary";
  }
};

const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

const formatSize = (bytes: number): string => {
  if (!bytes) return "N/A";
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / (1024 * 1024)).toFixed(1) + " MB";
};

const formatScore = (score: number): string => {
  if (!score) return "0.00";
  return score.toFixed(4);
};

const showToast = (message: string, type: "success" | "error" | "info") => {
  console.log(`[${type.toUpperCase()}] ${message}`);
  // Integrate with your toast library here
};

// Lifecycle
onMounted(() => {
  loadKnowledgeBase();
  loadDocuments();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/admin/knowledge-bases" }, {
            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
              _createTextVNode("Knowledge Bases", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, _toDisplayString(knowledgeBase.value?.name || "Details"), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[18] || (_cache[18] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
            ], -1),
            _createElementVNode("p", { class: "mt-2" }, "Loading knowledge base...", -1)
          ]))]))
        : (knowledgeBase.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("h4", _hoisted_15, [
                            _createTextVNode(_toDisplayString(knowledgeBase.value.name) + " ", 1),
                            _createElementVNode("span", {
                              class: _normalizeClass([
                          'badge',
                          'ms-2',
                          knowledgeBase.value.is_active ?? knowledgeBase.value.isActive
                            ? 'bg-success'
                            : 'bg-secondary',
                        ])
                            }, _toDisplayString(knowledgeBase.value.is_active ?? knowledgeBase.value.isActive
                            ? "Active"
                            : "Inactive"), 3),
                            (knowledgeBase.value.category)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(knowledgeBase.value.category?.name), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("p", _hoisted_17, _toDisplayString(knowledgeBase.value.description), 1),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", null, [
                              _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fa fa-file-text me-1 text-primary" }, null, -1)),
                              _cache[20] || (_cache[20] = _createElementVNode("strong", null, "Documents:", -1)),
                              _createTextVNode(" " + _toDisplayString(documents.value.length), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fa fa-calendar me-1 text-info" }, null, -1)),
                              _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Created:", -1)),
                              _createTextVNode(" " + _toDisplayString(formatDate(
                            knowledgeBase.value.created_at || knowledgeBase.value.createdAt
                          )), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_router_link, {
                              to: "/admin/knowledge-bases",
                              class: "btn btn-outline-secondary btn-sm"
                            }, {
                              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("i", { class: "fa fa-arrow-left me-1" }, null, -1),
                                _createTextVNode(" Back to List ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_router_link, {
                              to: `/admin/knowledge-bases/${knowledgeBaseId.value}/edit`,
                              class: "btn btn-primary btn-sm"
                            }, {
                              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                _createElementVNode("i", { class: "fa fa-edit me-1" }, null, -1),
                                _createTextVNode(" Edit ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("ul", _hoisted_25, [
                        _createElementVNode("li", _hoisted_26, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["nav-link", { active: activeTab.value === 'documents' }]),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'documents')),
                            type: "button"
                          }, [
                            _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fa fa-file-text me-1" }, null, -1)),
                            _cache[26] || (_cache[26] = _createTextVNode(" Documents ", -1)),
                            (documents.value.length > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(documents.value.length), 1))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]),
                        _createElementVNode("li", _hoisted_28, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["nav-link", { active: activeTab.value === 'retrieval-test' }]),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'retrieval-test')),
                            type: "button"
                          }, [...(_cache[27] || (_cache[27] = [
                            _createElementVNode("i", { class: "fa fa-search me-1" }, null, -1),
                            _createTextVNode(" Retrieval Test ", -1)
                          ]))], 2)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      (activeTab.value === 'documents')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _cache[32] || (_cache[32] = _createElementVNode("h6", { class: "mb-0 fw-bold" }, [
                                    _createElementVNode("i", { class: "fa fa-plus-circle text-primary me-2" }),
                                    _createTextVNode(" Add Knowledge Base Content ")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass(["btn rounded-pill px-3", uploadMethod.value === 'file' ? 'btn-primary shadow-sm' : 'btn-light border-0 text-muted']),
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (uploadMethod.value = 'file'))
                                    }, [...(_cache[28] || (_cache[28] = [
                                      _createElementVNode("i", { class: "fa fa-file-upload me-1" }, null, -1),
                                      _createTextVNode(" Upload File ", -1)
                                    ]))], 2),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass(["btn rounded-pill px-3", uploadMethod.value === 'url' ? 'btn-primary shadow-sm' : 'btn-light border-0 text-muted']),
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (uploadMethod.value = 'url'))
                                    }, [...(_cache[29] || (_cache[29] = [
                                      _createElementVNode("i", { class: "fa fa-link me-1" }, null, -1),
                                      _createTextVNode(" Add URL ", -1)
                                    ]))], 2),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass(["btn rounded-pill px-3", uploadMethod.value === 'text' ? 'btn-primary shadow-sm' : 'btn-light border-0 text-muted']),
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (uploadMethod.value = 'text'))
                                    }, [...(_cache[30] || (_cache[30] = [
                                      _createElementVNode("i", { class: "fa fa-text-width me-1" }, null, -1),
                                      _createTextVNode(" Add Text ", -1)
                                    ]))], 2),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass(["btn rounded-pill px-3", uploadMethod.value === 'prompt' ? 'btn-primary shadow-sm' : 'btn-light border-0 text-muted']),
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (uploadMethod.value = 'prompt'))
                                    }, [...(_cache[31] || (_cache[31] = [
                                      _createElementVNode("i", { class: "fa fa-terminal me-1" }, null, -1),
                                      _createTextVNode(" Add Prompt ", -1)
                                    ]))], 2)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                (uploadMethod.value === 'file')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                      _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                          _createElementVNode("div", {
                                            class: "custom-drop-zone d-flex align-items-center px-4",
                                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$refs.fileInputRef.click()))
                                          }, [
                                            _createElementVNode("div", _hoisted_39, [
                                              _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fa fa-file-upload fa-2x text-primary me-3" }, null, -1)),
                                              _createElementVNode("div", _hoisted_40, [
                                                (selectedFile.value)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(selectedFile.value.name), 1))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_42, " Click to browse or drag and drop your file here ")),
                                                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "d-flex gap-2 mt-1" }, [
                                                  _createElementVNode("span", { class: "badge bg-light text-primary border-primary-light small-badge" }, "PDF"),
                                                  _createElementVNode("span", { class: "badge bg-light text-primary border-primary-light small-badge" }, "DOCX"),
                                                  _createElementVNode("span", { class: "badge bg-light text-primary border-primary-light small-badge" }, "TXT")
                                                ], -1))
                                              ]),
                                              (selectedFile.value)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "btn btn-link btn-sm text-danger p-0 ms-2",
                                                    onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => {selectedFile.value = null; _ctx.$refs.fileInputRef.value = ''}, ["stop"]))
                                                  }, [...(_cache[34] || (_cache[34] = [
                                                    _createElementVNode("i", { class: "fa fa-times-circle" }, null, -1)
                                                  ]))]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("input", {
                                              type: "file",
                                              ref_key: "fileInputRef",
                                              ref: fileInputRef,
                                              onChange: handleFileSelect,
                                              accept: ".pdf,.docx,.txt",
                                              class: "d-none"
                                            }, null, 544)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_43, [
                                          _createElementVNode("button", {
                                            onClick: handleFileUpload,
                                            class: "btn btn-primary w-100 shadow-hover d-flex align-items-center justify-content-center unit-height",
                                            disabled: !selectedFile.value || isUploadingFile.value
                                          }, [
                                            (isUploadingFile.value)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, [...(_cache[36] || (_cache[36] = [
                                                  _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1),
                                                  _createTextVNode(" Uploading... ", -1)
                                                ]))]))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_46, [...(_cache[37] || (_cache[37] = [
                                                  _createElementVNode("i", { class: "fa fa-cloud-upload-alt me-2" }, null, -1),
                                                  _createTextVNode(" Start Upload ", -1)
                                                ]))]))
                                          ], 8, _hoisted_44)
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (uploadMethod.value === 'url')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("div", _hoisted_49, [
                                          _createElementVNode("div", _hoisted_50, [
                                            _createElementVNode("div", _hoisted_51, [
                                              _cache[38] || (_cache[38] = _createElementVNode("span", { class: "input-group-text bg-white border-end-0 border-light-2" }, [
                                                _createElementVNode("i", { class: "fa fa-link text-muted" })
                                              ], -1)),
                                              _withDirectives(_createElementVNode("input", {
                                                type: "url",
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((urlInput).value = $event)),
                                                class: "form-control border-start-0 border-light-2 unit-height",
                                                placeholder: "https://example.com/article"
                                              }, null, 512), [
                                                [_vModelText, urlInput.value]
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_52, [
                                          _createElementVNode("div", _hoisted_53, [
                                            _cache[39] || (_cache[39] = _createElementVNode("span", { class: "input-group-text bg-white border-end-0 border-light-2" }, [
                                              _createElementVNode("i", { class: "fa fa-tag text-muted" })
                                            ], -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((urlTitle).value = $event)),
                                              class: "form-control border-start-0 border-light-2 unit-height",
                                              placeholder: "Title (optional)"
                                            }, null, 512), [
                                              [_vModelText, urlTitle.value]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("button", {
                                            onClick: handleAddUrl,
                                            class: "btn btn-primary w-100 shadow-hover unit-height d-flex align-items-center justify-content-center",
                                            disabled: !urlInput.value || isAddingUrl.value
                                          }, [
                                            (isAddingUrl.value)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_56, [...(_cache[40] || (_cache[40] = [
                                                  _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1),
                                                  _createTextVNode(" Adding... ", -1)
                                                ]))]))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_57, [...(_cache[41] || (_cache[41] = [
                                                  _createElementVNode("i", { class: "fa fa-plus-circle me-2" }, null, -1),
                                                  _createTextVNode(" Add URL ", -1)
                                                ]))]))
                                          ], 8, _hoisted_55)
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (uploadMethod.value === 'text')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      _createElementVNode("div", { class: "row g-3" }, [
                                        _cache[43] || (_cache[43] = _createStaticVNode("<div class=\"col-lg-8\" data-v-11d60957><div class=\"custom-drop-zone d-flex align-items-center px-4 mb-0 unit-height\" data-v-11d60957><div class=\"d-flex align-items-center w-100\" data-v-11d60957><i class=\"fa fa-file-alt fa-2x text-primary me-3\" data-v-11d60957></i><div class=\"flex-grow-1 overflow-hidden\" data-v-11d60957><div class=\"fw-bold text-dark\" data-v-11d60957>Manually Add Text Content</div><div class=\"text-muted small\" data-v-11d60957>Perfect for FAQs, policies, and custom notes</div></div></div></div></div>", 1)),
                                        _createElementVNode("div", { class: "col-lg-4" }, [
                                          _createElementVNode("button", {
                                            onClick: showAddTextModal,
                                            class: "btn btn-primary w-100 shadow-hover d-flex align-items-center justify-content-center unit-height"
                                          }, [...(_cache[42] || (_cache[42] = [
                                            _createElementVNode("i", { class: "fa fa-edit me-2" }, null, -1),
                                            _createTextVNode(" Open Text Editor ", -1)
                                          ]))])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (uploadMethod.value === 'prompt')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                      _createElementVNode("div", { class: "row g-3" }, [
                                        _cache[45] || (_cache[45] = _createStaticVNode("<div class=\"col-lg-8\" data-v-11d60957><div class=\"custom-drop-zone d-flex align-items-center px-4 mb-0 unit-height\" data-v-11d60957><div class=\"d-flex align-items-center w-100\" data-v-11d60957><i class=\"fa fa-terminal fa-2x text-primary me-3\" data-v-11d60957></i><div class=\"flex-grow-1 overflow-hidden\" data-v-11d60957><div class=\"fw-bold text-dark\" data-v-11d60957>Generate from Prompt</div><div class=\"text-muted small\" data-v-11d60957>Enter a title and prompt to generate knowledge base content</div></div></div></div></div>", 1)),
                                        _createElementVNode("div", { class: "col-lg-4" }, [
                                          _createElementVNode("button", {
                                            onClick: showAddPromptModal,
                                            class: "btn btn-primary w-100 shadow-hover d-flex align-items-center justify-content-center unit-height"
                                          }, [...(_cache[44] || (_cache[44] = [
                                            _createElementVNode("i", { class: "fa fa-magic me-2" }, null, -1),
                                            _createTextVNode(" Open Prompt Editor ", -1)
                                          ]))])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (isLoadingDocuments.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [...(_cache[46] || (_cache[46] = [
                                  _createElementVNode("div", {
                                    class: "spinner-border text-primary",
                                    role: "status"
                                  }, [
                                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                  ], -1)
                                ]))]))
                              : (documents.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [...(_cache[47] || (_cache[47] = [
                                    _createElementVNode("i", { class: "fa fa-folder-open fa-3x text-muted mb-3" }, null, -1),
                                    _createElementVNode("p", { class: "text-muted" }, "No documents added yet", -1),
                                    _createElementVNode("small", { class: "text-muted" }, " Upload files, add URLs, or paste text to populate this knowledge base ", -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _createElementVNode("table", _hoisted_63, [
                                      _cache[50] || (_cache[50] = _createElementVNode("thead", { class: "table-dark" }, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", null, "Title"),
                                          _createElementVNode("th", null, "Type"),
                                          _createElementVNode("th", null, "Status"),
                                          _createElementVNode("th", null, "Added On"),
                                          _createElementVNode("th", { class: "text-end" }, "Actions")
                                        ])
                                      ], -1)),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value, (doc) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: doc._id || doc.id
                                          }, [
                                            _createElementVNode("td", null, [
                                              _createElementVNode("strong", null, _toDisplayString(doc.title), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass([
                                'badge',
                                getSourceTypeBadgeClass(
                                  doc.source_type || doc.sourceType
                                ),
                              ])
                                              }, _toDisplayString(doc.source_type || doc.sourceType), 3)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass([
                                'badge',
                                getStatusBadgeClass(doc.status),
                              ])
                                              }, _toDisplayString(doc.status), 3)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("small", null, _toDisplayString(formatDate(doc.created_at || doc.createdAt)), 1)
                                            ]),
                                            _createElementVNode("td", _hoisted_64, [
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (viewDocument(doc)),
                                                class: "btn btn-outline-primary btn-sm me-1",
                                                title: "View Details"
                                              }, [...(_cache[48] || (_cache[48] = [
                                                _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                                              ]))], 8, _hoisted_65),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (confirmDeleteDocument(doc)),
                                                class: "btn btn-outline-danger btn-sm",
                                                title: "Delete"
                                              }, [...(_cache[49] || (_cache[49] = [
                                                _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                              ]))], 8, _hoisted_66)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                          ]))
                        : _createCommentVNode("", true),
                      (activeTab.value === 'retrieval-test')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _createElementVNode("div", _hoisted_70, [
                                  _cache[55] || (_cache[55] = _createElementVNode("h6", { class: "mb-3" }, "Test Knowledge Base Retrieval", -1)),
                                  _cache[56] || (_cache[56] = _createElementVNode("p", { class: "text-muted" }, " Enter a query to test how well the knowledge base retrieves relevant information ", -1)),
                                  _createElementVNode("div", _hoisted_71, [
                                    _cache[51] || (_cache[51] = _createElementVNode("label", {
                                      for: "testQuery",
                                      class: "form-label"
                                    }, " Query ", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                      id: "testQuery",
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((testQuery).value = $event)),
                                      class: "form-control",
                                      rows: "3",
                                      placeholder: "Enter your query here..."
                                    }, null, 512), [
                                      [_vModelText, testQuery.value]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("div", _hoisted_73, [
                                      _cache[52] || (_cache[52] = _createElementVNode("label", {
                                        for: "topK",
                                        class: "form-label"
                                      }, " Top K Results ", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        id: "topK",
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((topK).value = $event)),
                                        class: "form-control",
                                        min: "1",
                                        max: "20",
                                        placeholder: "5"
                                      }, null, 512), [
                                        [
                                          _vModelText,
                                          topK.value,
                                          void 0,
                                          { number: true }
                                        ]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("button", {
                                    onClick: handleTestRetrieval,
                                    class: "btn btn-primary",
                                    disabled: !testQuery.value || isTesting.value
                                  }, [
                                    (isTesting.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_75, [...(_cache[53] || (_cache[53] = [
                                          _createElementVNode("span", { class: "spinner-border spinner-border-sm me-1" }, null, -1),
                                          _createTextVNode(" Testing... ", -1)
                                        ]))]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_76, [...(_cache[54] || (_cache[54] = [
                                          _createElementVNode("i", { class: "fa fa-search me-1" }, null, -1),
                                          _createTextVNode(" Test Retrieval ", -1)
                                        ]))]))
                                  ], 8, _hoisted_74)
                                ]),
                                (testResults.value.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                      _createElementVNode("h6", _hoisted_78, "Results (" + _toDisplayString(testResults.value.length) + ")", 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testResults.value, (result, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: index,
                                          class: "card mb-3"
                                        }, [
                                          _createElementVNode("div", _hoisted_79, [
                                            _createElementVNode("div", _hoisted_80, [
                                              _createElementVNode("h6", _hoisted_81, _toDisplayString(result.document_title ||
                                  result.title ||
                                  "Document"), 1),
                                              _createElementVNode("span", _hoisted_82, " Score: " + _toDisplayString(formatScore(result.score)), 1)
                                            ]),
                                            _createElementVNode("p", _hoisted_83, [
                                              _cache[57] || (_cache[57] = _createElementVNode("i", { class: "fa fa-file me-1" }, null, -1)),
                                              _createTextVNode(" " + _toDisplayString(result.source_type || result.sourceType), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_84, _toDisplayString(result.content || result.chunk_text), 1)
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : (testResults.value.length === 0 && hasTestedOnce.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [...(_cache[58] || (_cache[58] = [
                                        _createElementVNode("i", { class: "fa fa-info-circle me-2" }, null, -1),
                                        _createTextVNode(" No results found for your query ", -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_86, [
              _cache[60] || (_cache[60] = _createElementVNode("i", { class: "fa fa-exclamation-triangle fa-3x text-danger mb-3" }, null, -1)),
              _cache[61] || (_cache[61] = _createElementVNode("p", { class: "text-danger" }, "Failed to load knowledge base", -1)),
              _createVNode(_component_router_link, {
                to: "/admin/knowledge-bases",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                  _createTextVNode(" Back to Knowledge Bases ", -1)
                ]))]),
                _: 1
              })
            ]))
    ]),
    _createElementVNode("div", {
      class: "modal fade",
      id: "addTextModal",
      tabindex: "-1",
      ref_key: "addTextModalRef",
      ref: addTextModalRef
    }, [
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _cache[67] || (_cache[67] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Add Text Content"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _cache[62] || (_cache[62] = _createElementVNode("label", {
                for: "textTitle",
                class: "form-label"
              }, [
                _createTextVNode(" Title "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "textTitle",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((textTitle).value = $event)),
                class: "form-control",
                placeholder: "Enter a title for this content"
              }, null, 512), [
                [_vModelText, textTitle.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _cache[63] || (_cache[63] = _createElementVNode("label", {
                for: "textContent",
                class: "form-label"
              }, [
                _createTextVNode(" Content "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                id: "textContent",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((textContent).value = $event)),
                class: "form-control",
                rows: "10",
                placeholder: "Paste or type your content here..."
              }, null, 512), [
                [_vModelText, textContent.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_92, [
            _cache[66] || (_cache[66] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: handleAddText,
              disabled: !textTitle.value || !textContent.value || isAddingText.value
            }, [
              (isAddingText.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_94, [...(_cache[64] || (_cache[64] = [
                    _createElementVNode("span", {
                      class: "spinner-border spinner-border-sm me-1",
                      role: "status"
                    }, null, -1),
                    _createTextVNode(" Adding... ", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("span", _hoisted_95, [...(_cache[65] || (_cache[65] = [
                    _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                    _createTextVNode(" Add Content ", -1)
                  ]))]))
            ], 8, _hoisted_93)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      class: "modal fade",
      id: "addPromptModal",
      tabindex: "-1",
      ref_key: "addPromptModalRef",
      ref: addPromptModalRef
    }, [
      _createElementVNode("div", _hoisted_96, [
        _createElementVNode("div", _hoisted_97, [
          _cache[73] || (_cache[73] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Generate Content from Prompt"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _cache[68] || (_cache[68] = _createElementVNode("label", {
                for: "promptTitle",
                class: "form-label"
              }, [
                _createTextVNode(" Title "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "promptTitle",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((promptTitle).value = $event)),
                class: "form-control",
                placeholder: "Enter a title for this generated content"
              }, null, 512), [
                [_vModelText, promptTitle.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _cache[69] || (_cache[69] = _createElementVNode("label", {
                for: "promptTextContent",
                class: "form-label"
              }, [
                _createTextVNode(" Prompt "),
                _createElementVNode("span", { class: "text-danger" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("textarea", {
                id: "promptTextContent",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((promptInput).value = $event)),
                class: "form-control",
                rows: "6",
                placeholder: "E.g., Create a knowledge base for a software engineering team focusing on high-level architecture..."
              }, null, 512), [
                [_vModelText, promptInput.value]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _cache[72] || (_cache[72] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: handleGeneratePrompt,
              disabled: !promptTitle.value || !promptInput.value || isGeneratingPrompt.value
            }, [
              (isGeneratingPrompt.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_103, [...(_cache[70] || (_cache[70] = [
                    _createElementVNode("span", {
                      class: "spinner-border spinner-border-sm me-1",
                      role: "status"
                    }, null, -1),
                    _createTextVNode(" Generating... ", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("span", _hoisted_104, [...(_cache[71] || (_cache[71] = [
                    _createElementVNode("i", { class: "fa fa-magic me-1" }, null, -1),
                    _createTextVNode(" Generate ", -1)
                  ]))]))
            ], 8, _hoisted_102)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      class: "modal fade",
      id: "deleteDocumentModal",
      tabindex: "-1",
      ref_key: "deleteDocumentModalRef",
      ref: deleteDocumentModalRef
    }, [
      _createElementVNode("div", _hoisted_105, [
        _createElementVNode("div", _hoisted_106, [
          _cache[80] || (_cache[80] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Confirm Delete"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("p", null, [
              _cache[74] || (_cache[74] = _createTextVNode(" Are you sure you want to delete ", -1)),
              _createElementVNode("strong", null, _toDisplayString(documentToDelete.value?.title), 1),
              _cache[75] || (_cache[75] = _createTextVNode("? ", -1))
            ]),
            _cache[76] || (_cache[76] = _createElementVNode("p", { class: "text-danger" }, [
              _createElementVNode("i", { class: "fa fa-exclamation-triangle me-1" }),
              _createTextVNode(" This action cannot be undone. ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_108, [
            _cache[79] || (_cache[79] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: deleteDocument,
              disabled: isDeletingDocument.value
            }, [
              (isDeletingDocument.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_110, [...(_cache[77] || (_cache[77] = [
                    _createElementVNode("span", {
                      class: "spinner-border spinner-border-sm me-1",
                      role: "status"
                    }, null, -1),
                    _createTextVNode(" Deleting... ", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("span", _hoisted_111, [...(_cache[78] || (_cache[78] = [
                    _createElementVNode("i", { class: "fa fa-trash me-1" }, null, -1),
                    _createTextVNode(" Delete ", -1)
                  ]))]))
            ], 8, _hoisted_109)
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})